var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 102 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.023 4.87l-4.717 7.738s-17.92 24.576 20.48 63.248l-.007.005c.061.061.122.114.183.175.061.061.113.122.174.183l.009-.008c38.668 38.404 63.244 20.483 63.244 20.483l7.739-4.717c4.441-3.331 4.902-9.823.976-13.75l-9.23-9.231a9.121 9.121 0 00-11.924-.847l-9.824 6.279s-6.6 3.898-25.062-14.492C23.672 41.474 27.569 34.871 27.569 34.871l6.28-9.821a9.122 9.122 0 00-.847-11.924l-9.229-9.232C19.847-.033 13.352.429 10.023 4.87z",
    fill: "url(#phone_inline_svg__phone_inline_svg___Linear1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.925 4.662l-4.734 7.765s-17.983 24.663 20.553 63.47l-.008.006c.062.061.123.114.184.176.061.061.114.122.175.183l.009-.008c38.805 38.539 63.468 20.555 63.468 20.555l7.766-4.733c4.457-3.344 4.92-9.858.98-13.799l-9.262-9.264a9.156 9.156 0 00-11.967-.849l-9.859 6.301s-6.623 3.911-25.15-14.543C23.622 41.395 27.533 34.769 27.533 34.769l6.302-9.856a9.154 9.154 0 00-.849-11.966l-9.262-9.265c-3.941-3.94-10.458-3.477-13.799.98z",
    fill: "none",
    stroke: "#364148",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_inline_svg__phone_inline_svg___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.13 51.046) scale(99.6471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005791",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0086c7",
    stopOpacity: 1
  })))));
}

export default SvgPhoneinline;